export const RESPONSIVE_BREAKPOINT = 680;
export const MAPBOX_TOKEN = "pk.eyJ1IjoiYW5kcmVwZXJlaXJhIiwiYSI6ImNsMjY0dDJsZjAxdjkzZW42MzZuc2xmaHQifQ.LBWNJEVlFAlTgpW4U6ebZA"
export const MAPBOX_TOKEN_URL = `https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=${MAPBOX_TOKEN}`;